(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-box-quote-form"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.customBoxQuoteFormBound) return;
    window.customBoxQuoteFormBound = true;

    const getRoot = (element) => element.closest('[data-custom-box-quote]');
    const getProductInfo = (root) => root.closest('.product__info-container');

    const getDimensions = (root) => {
      const values = {};
      root.querySelectorAll('[data-quote-dimension]').forEach((input) => {
        values[input.dataset.quoteDimension] = Number(input.value);
      });
      return values;
    };

    const dimensionState = new WeakMap();
    const dimensionKeys = ['length', 'width', 'height'];
    const dimensionLoadingTimers = new WeakMap();
    const setDimensionsLoading = (root, loading) => {
      root.dataset.dimensionsLoading = loading ? 'true' : 'false';
      root.querySelector('.custom-box-quote__dimensions')?.setAttribute('aria-busy', loading ? 'true' : 'false');
      root.querySelectorAll('[data-quote-dimension]').forEach((input) => { input.readOnly = loading; });
      root.querySelectorAll('[data-quote-unit-option]').forEach((option) => { option.disabled = loading; });
      if (!loading) {
        clearTimeout(dimensionLoadingTimers.get(root));
        dimensionLoadingTimers.delete(root);
      }
    };
    const startDimensionsLoading = (root) => {
      clearTimeout(dimensionLoadingTimers.get(root));
      setDimensionsLoading(root, true);
      dimensionLoadingTimers.set(root, setTimeout(() => setDimensionsLoading(root, false), 11000));
    };
    const currentMillimeters = (root) => {
      const multiplier = root.querySelector('[data-quote-unit]').value === 'in' ? 25.4 : 1;
      return dimensionKeys.map((key) => {
        const input = root.querySelector(`[data-quote-dimension="${key}"]`);
        return input.dataset.displayValue === input.value
          ? Number(input.dataset.millimeters)
          : Number(input.value) * multiplier;
      });
    };
    const validDimensions = (values) => Array.isArray(values) &&
      values.length === dimensionKeys.length &&
      values.every((value) => Number.isFinite(value) && value > 0);
    const dimensionsMatch = (actual, requested) => validDimensions(actual) &&
      actual.every((value, index) => Math.abs(value - requested[index]) <= 0.01);
    const waitForAppliedDimensions = async (requested, previous, timeout = 12000) => {
      const startedAt = Date.now();
      let delay = 150;
      let lastError;
      let stableValues;
      let stableReads = 0;
      let stableSince = 0;
      while (Date.now() - startedAt < timeout) {
        try {
          const info = await window.Pacdora.getBoxInfo();
          const actual = dimensionKeys.map((key) => Number(info?.[key]));
          if (dimensionsMatch(actual, requested)) return { info, values: actual, adjusted: false };
          const changedFromPrevious = !validDimensions(previous) || !dimensionsMatch(actual, previous);
          if (validDimensions(actual) && changedFromPrevious) {
            if (stableValues && dimensionsMatch(actual, stableValues)) {
              stableReads += 1;
            } else {
              stableValues = actual;
              stableReads = 1;
              stableSince = Date.now();
            }
            if (stableReads >= 3 && Date.now() - stableSince >= 750) {
              return { info, values: actual, adjusted: true };
            }
          }
        } catch (error) {
          lastError = error;
        }
        await new Promise((resolve) => setTimeout(resolve, delay));
        delay = Math.min(Math.round(delay * 1.5), 1500);
      }
      throw lastError || new Error('Model did not confirm requested dimensions before timeout');
    };
    const modelReadTimers = new WeakMap();
    const refreshApply = (root) => {
      const state = dimensionState.get(root);
      const values = currentMillimeters(root);
      const dirty = state?.applied
        ? values.some((value, index) => !Number.isFinite(value) || Math.abs(value - state.applied[index]) > 0.000001)
        : root.dataset.dimensionsDirty === 'true';
      const button = root.querySelector('[data-quote-update-preview]');
      button.hidden = !dirty;
      root.querySelector('.custom-box-quote__preview-row').hidden = !dirty && !root.querySelector('[data-quote-preview-status]').textContent;
      syncDimensions(root);
    };
    const writeDimensions = (root, values, unit) => {
      const multiplier = unit === 'in' ? 25.4 : 1;
      dimensionKeys.forEach((key, index) => {
        const input = root.querySelector(`[data-quote-dimension="${key}"]`);
        if (!Number.isFinite(values[index]) || values[index] <= 0) return;
        input.value = Number((values[index] / multiplier).toFixed(6));
        input.dataset.millimeters = values[index];
        input.dataset.displayValue = input.value;
        input.setCustomValidity('');
      });
    };

    const parseDimensions = (rawSize) => {
      if (!rawSize || typeof rawSize !== 'string') return null;
      const values = rawSize.match(/[0-9]+(?:\.[0-9]+)?/g)?.map(Number) || [];
      return values.length === 3 && values.every((value) => value > 0) ? values : null;
    };

    const syncDimensions = (root) => {
      const dimensions = getDimensions(root);
      const unit = root.querySelector('[data-quote-unit]').value;
      const output = root.querySelector('[data-quote-dimensions]');
      if (dimensions.length > 0 && dimensions.width > 0 && dimensions.height > 0) {
        output.value = `${dimensions.length} × ${dimensions.width} × ${dimensions.height} ${unit}`;
      } else {
        output.value = '';
      }
      return { dimensions, unit };
    };

    const applyDefaultDimensions = (root, rawSize) => {
      const values = parseDimensions(rawSize);
      if (!values) return false;

      const unit = /\b(?:inch|inches|in)\b/i.test(rawSize) ? 'in' : 'mm';
      const [length, width, height] = values;
      root.querySelector('[data-quote-dimension="length"]').value = length;
      root.querySelector('[data-quote-dimension="width"]').value = width;
      root.querySelector('[data-quote-dimension="height"]').value = height;
      root.querySelector('[data-quote-unit]').value = unit;
      root.querySelectorAll('[data-quote-unit-option]').forEach((option) => {
        const isActive = option.dataset.quoteUnitOption === unit;
        option.classList.toggle('is-active', isActive);
        option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      root.querySelector('[data-quote-preview-status]').textContent = '';
      const multiplier = unit === 'in' ? 25.4 : 1;
      const applied = values.map((value) => value * multiplier);
      dimensionState.set(root, { applied });
      writeDimensions(root, applied, unit);
      refreshApply(root);
      return true;
    };

    const getSelectedVariant = (root) => {
      const productInfo = getProductInfo(root);
      const selectedValues = Array.from(productInfo.querySelectorAll('variant-selects input:checked, variant-selects select'))
        .map((input) => input.value)
        .filter(Boolean);
      const variants = window.PRODUCT_DATA?.variants || [];
      return variants.find((variant) => variant.options?.every((option, index) => option.name === selectedValues[index]));
    };

    const mountVariantPicker = (root) => {
      const productInfo = getProductInfo(root);
      const slot = root.querySelector('[data-quote-options-slot]');
      const picker = productInfo?.querySelector('variant-selects');
      if (!slot || !picker) return;
      slot.hidden = false;
      if (!slot.contains(picker)) slot.append(picker);
    };

    const mountPacdoraDesign = (root) => {
      const productInfo = getProductInfo(root);
      const slot = root.querySelector('[data-quote-design-slot]');
      const design = productInfo?.querySelector('.pacdora-design');
      if (!slot || !design) return;
      slot.hidden = false;
      if (!slot.contains(design)) slot.append(design);
    };

    const clampQuantity = (root) => {
      const input = root.querySelector('[data-quote-quantity]');
      const moq = Number(root.dataset.moq || 1);
      const value = Math.floor(Number(input.value));
      input.value = Number.isFinite(value) && value >= moq ? value : moq;
    };

    const syncSelectedOptions = (root) => {
      const productInfo = getProductInfo(root);
      const selectedOptions = Array.from(productInfo.querySelectorAll('variant-selects input:checked, variant-selects select'))
        .map((input) => input.value)
        .filter(Boolean);
      root.querySelector('[data-quote-selected-options]').value = selectedOptions.join(' / ');
    };

    const syncVariantDefaults = (root, variant) => {
      mountVariantPicker(root);
      syncSelectedOptions(root);
      const size = variant?.metafields?.size || root.dataset.defaultSize;
      if (root.dataset.dimensionsDirty !== 'true' && size) applyDefaultDimensions(root, size);
    };

    const updatePreview = async (root) => {
      const state = dimensionState.get(root) || {};
      if (state.applying) return;
      const status = root.querySelector('[data-quote-preview-status]');
      const values = currentMillimeters(root);
      const inputs = Array.from(root.querySelectorAll('[data-quote-dimension]'));
      const invalid = inputs.find((input) => !input.checkValidity()) ||
        inputs.find((input, index) => !Number.isFinite(values[index]) || values[index] <= 0);
      if (invalid) {
        invalid.setCustomValidity('Enter a positive dimension.');
        invalid.reportValidity();
        return;
      }
      if (!window.Pacdora || typeof window.Pacdora.setSize !== 'function') {
        status.textContent = 'Preview is loading. Please try Apply again shortly.';
        refreshApply(root);
        return;
      }
      state.applying = true;
      dimensionState.set(root, state);
      const button = root.querySelector('[data-quote-update-preview]');
      const controls = [...inputs, ...root.querySelectorAll('[data-quote-unit-option]'), button];
      controls.forEach((control) => { control.disabled = true; });
      button.textContent = 'Applying…';
      status.textContent = 'Updating the 3D preview…';
      try {
        let previous = state.applied;
        try {
          const previousInfo = await window.Pacdora.getBoxInfo();
          const previousValues = dimensionKeys.map((key) => Number(previousInfo?.[key]));
          if (validDimensions(previousValues)) previous = previousValues;
        } catch (error) {
          // The existing state is sufficient if Pacdora is temporarily busy.
        }
        await window.Pacdora.setSize({ length: values[0], width: values[1], height: values[2], async: true });
        const applied = await waitForAppliedDimensions(values, previous);
        state.applied = applied.values;
        root.dataset.dimensionsDirty = 'false';
        writeDimensions(root, applied.values, root.querySelector('[data-quote-unit]').value);
        root.querySelector('[data-quote-pacdora-project-id]').value = applied.info.id || '';
        status.textContent = applied.adjusted
          ? 'Dimensions were adjusted to the nearest valid combination for this structure.'
          : '';
      } catch (error) {
        status.textContent = 'The 3D preview could not update. Your entered dimensions are still saved with the quote. Please try Apply again.';
        console.warn('Pacdora could not apply quote dimensions:', error);
      } finally {
        state.applying = false;
        controls.forEach((control) => { control.disabled = false; });
        button.textContent = 'Apply';
        refreshApply(root);
        if (button.hidden) inputs[0]?.focus();
      }
    };

    const readModelDimensions = async (root) => {
      if (root.dataset.dimensionsDirty === 'true' || dimensionState.get(root)?.applying) return false;
      try {
        const info = await window.Pacdora.getBoxInfo();
        if (!info || root.dataset.dimensionsDirty === 'true' || dimensionState.get(root)?.applying || !root.isConnected) return false;
        const values = dimensionKeys.map((key) => Number(info[key]));
        if (!validDimensions(values)) return false;
        dimensionState.set(root, { applied: values });
        writeDimensions(root, values, root.querySelector('[data-quote-unit]').value);
        root.querySelector('[data-quote-pacdora-project-id]').value = info.id || '';
        refreshApply(root);
        setDimensionsLoading(root, false);
        return true;
      } catch (error) {
        return false;
      }
    };

    const scheduleModelRead = (root, attempt = 0) => {
      clearTimeout(modelReadTimers.get(root));
      if (!root.isConnected) return;
      if (root.dataset.dimensionsDirty === 'true') {
        setDimensionsLoading(root, false);
        return;
      }
      readModelDimensions(root).then((complete) => {
        if (complete || root.dataset.dimensionsDirty === 'true') return;
        if (attempt >= 20) {
          setDimensionsLoading(root, false);
          return;
        }
        modelReadTimers.set(root, setTimeout(() => scheduleModelRead(root, attempt + 1), 500));
      });
    };

    let boundSdk;
    const bindModelDimensions = () => {
      const sdk = window.Pacdora;
      if (!sdk || typeof sdk.getBoxInfo !== 'function' || boundSdk === sdk) return;
      boundSdk = sdk;
      const readAll = () => document.querySelectorAll('[data-custom-box-quote]').forEach((root) => scheduleModelRead(root));
      sdk.$on('3d:init', readAll);
      sdk.$on('project:change', readAll);
      readAll();
    };

    const initializeRoot = (root) => {
      if (!root || root.dataset.quoteInitialized === 'true') return;
      root.dataset.quoteInitialized = 'true';
      startDimensionsLoading(root);
      mountVariantPicker(root);
      mountPacdoraDesign(root);
      syncVariantDefaults(root, getSelectedVariant(root));
      refreshApply(root);
      bindModelDimensions();
      if (boundSdk) scheduleModelRead(root);
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll?.('[data-custom-box-quote]').forEach(initializeRoot);
    };

    document.addEventListener('change', (event) => {
      const root = getRoot(event.target);
      if (!root) return;

      if (event.target.matches('[data-quote-dimension]')) {
        root.dataset.dimensionsDirty = 'true';
        refreshApply(root);
      }

      if (event.target.matches('[data-quote-quantity]')) clampQuantity(root);

      if (event.target.closest('variant-selects')) {
        startDimensionsLoading(root);
        syncVariantDefaults(root, getSelectedVariant(root));
        if (boundSdk) scheduleModelRead(root);
      }
    });

    document.addEventListener('input', (event) => {
      const root = getRoot(event.target);
      if (!root) return;
      if (event.target.matches('[data-quote-dimension]')) {
        root.dataset.dimensionsDirty = 'true';
        event.target.setCustomValidity('');
        root.querySelector('[data-quote-preview-status]').textContent = '';
        refreshApply(root);
      }
    });

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-quote-update-preview]');
      if (button) {
        updatePreview(getRoot(button));
        return;
      }

      const unitOption = event.target.closest('[data-quote-unit-option]');
      if (unitOption) {
        const root = getRoot(unitOption);
        const value = unitOption.dataset.quoteUnitOption;
        if (root.querySelector('[data-quote-unit]').value === value) return;
        const values = currentMillimeters(root);
        root.querySelector('[data-quote-unit]').value = value;
        root.querySelectorAll('[data-quote-unit-option]').forEach((option) => {
          const isActive = option === unitOption;
          option.classList.toggle('is-active', isActive);
          option.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        writeDimensions(root, values, value);
        refreshApply(root);
        return;
      }
    });

    document.addEventListener('submit', async (event) => {
      const root = getRoot(event.target);
      if (!root) return;

      if (root.dataset.quoteSubmitReady === 'true') {
        delete root.dataset.quoteSubmitReady;
        return;
      }

      if (dimensionState.get(root)?.applying) {
        event.preventDefault();
        return;
      }
      const dimensionInputs = Array.from(root.querySelectorAll('[data-quote-dimension]'));
      syncDimensions(root);
      syncSelectedOptions(root);
      clampQuantity(root);
      const invalidDimension = dimensionInputs.find((input) => !Number.isFinite(Number(input.value)) || Number(input.value) <= 0);
      if (invalidDimension) {
        event.preventDefault();
        invalidDimension.setCustomValidity('Enter a valid dimension.');
        invalidDimension.reportValidity();
        return;
      }
      dimensionInputs.forEach((input) => input.setCustomValidity(''));

      if (root.dataset.quoteCapturingProject === 'true') {
        event.preventDefault();
        return;
      }

      if (window.Pacdora && typeof window.Pacdora.getBoxInfo === 'function') {
        event.preventDefault();
        root.dataset.quoteCapturingProject = 'true';
        try {
          const info = await window.Pacdora.getBoxInfo();
          root.querySelector('[data-quote-pacdora-project-id]').value = info?.id || '';
        } catch (error) {
          root.querySelector('[data-quote-pacdora-project-id]').value = '';
        } finally {
          delete root.dataset.quoteCapturingProject;
          root.dataset.quoteSubmitReady = 'true';
          event.target.requestSubmit(event.submitter || undefined);
        }
      }
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const root = document.querySelector(`[data-custom-box-quote][data-section-id="${event?.data?.sectionId}"]`);
        if (root) {
          startDimensionsLoading(root);
          syncVariantDefaults(root, event.data.variant);
          if (boundSdk) scheduleModelRead(root);
        }
      });
    }

    document.addEventListener('load', (event) => {
      if (event.target.tagName === 'SCRIPT') bindModelDimensions();
    }, true);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
